export { default } from './LinkedAccountModal.container';



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/LinkedAccountModal/index.js